import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../../../core/services/user.service';
import { APP_AVAILABILITY, APP_STATUS } from '../../enums';
import { CustomApp } from '../../dto';

@Pipe({
    name: 'isAppEnabledForAdmin',
    standalone: false
})
export class IsAppEnabledForAdminPipe implements PipeTransform {
    appAvailability: typeof APP_AVAILABILITY = APP_AVAILABILITY;
    appStatus: typeof APP_STATUS = APP_STATUS;

    constructor(private userService: UserService) {}

    transform(app: CustomApp, checkDisabled: boolean = false): boolean {
      const mainCondition = ((app?.availability === this.appAvailability?.ENABLED_FOR_ADMINS && this.userService.isAdmin())
        || app?.availability !== this.appAvailability?.ENABLED_FOR_ADMINS);

      const availabilityCondition = app?.availability !== this.appAvailability.DISABLED

      const statusCondition = app?.status === this.appStatus.ACTIVE;

      return !checkDisabled ? mainCondition : availabilityCondition && statusCondition && mainCondition;
  }
}
